import { ComponentStyleConfig } from "@chakra-ui/react";

export const Table: ComponentStyleConfig = {
	baseStyle: {
		td: {
			textAlign: "center",
		},
	},
};
